// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import socket from './utils/socket'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import VTooltip from 'v-tooltip'
import { getUrlParam } from '@/common/js/utils'
import Methods from './plugins/methods'
// import 'babel-polyfill'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(socket)
Vue.use(VTooltip)
Vue.use(Methods)

router.beforeEach((to, from, next) => {
  var token = getUrlParam('token')
  var source = getUrlParam('source')
  console.log('router--------', token)
  // 对接saas服务，判断地址有无token
  if (token) {
    window.localStorage.setItem('accessToken', token)
  }
  if (source) {
    window.localStorage.setItem('source', source)
  }
  // 判断该路由是否需要登录权限
  if (to.meta.requireAuth) {
    // 通过vuex state获取当前的token是否存在
    // console.log(isEmptyObject(store.state.user))
    console.log('to.meta.requireAuth', to.meta.requireAuth)
    let accessToken = window.localStorage.getItem('accessToken')
    if (accessToken) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js